export default __webpack_public_path__ + "7b653e66d5b274474f9d1ba32e20a6bf.png";